jQuery( document ).ready( function(){

    var perPage = 10; // How many to display per 'loadmore' click
  
  //   load more posts button
  jQuery(function($) {
    var cat = $( '.more-posts' ).data('category') ?? ""; // category ID
    var catCount = $( '.more-posts' ).data('count') ?? 0; // category post count
    var offset = $( '.more-posts' ).data('offset') ?? 0; // category post offset (start posts after this offset)
    var exclude = $( '.more-posts' ).data('exclude') ?? new Array(); // exclude posts array in JSON

    var fromPost = offset;

    
    $('body').on('click', '.loadmore', function() {
        var data = {
            'action': 'load_posts_by_ajax',
            'offset': offset,
            'perpage': perPage,
            'security': blog.security,
            'category': cat,
            'count' : catCount,
            'exclude': exclude,
        };
  
        $.post(blog.ajaxurl, data, function(response) {
            fromPost = offset + perPage
            if($.trim(response) != '') {
                $('.more-posts').append(response);
                offset = fromPost;
            } 
            if(fromPost >= catCount) {
                $('.loadmore').hide();
            }
            // console.log(fromPost); console.log(catCount);
        });
    });
  });

});